export const OPERATION_TYPE_ORDER_ID = 'ORDER'
export const OPERATION_TYPE_FINANCIAL_ID = 'FINANCIAL'
export const OPERATION_TYPE_EQUIPMENT_ID = 'EQUIPMENT'

export default class OperationType {
	/**
	 * @param {string} id
	 */
	constructor(id) {
		this.id = id;
	}

	static createFromJson = (json) => {
		if (!json) return null
		return new OperationType(json.id)
	}
}


// WEBPACK FOOTER //
// ./src/model/operation-type.js